import script from "./SalesmanDealRecordManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesmanDealRecordManagement.vue?vue&type=script&setup=true&lang=js"

import "./SalesmanDealRecordManagement.vue?vue&type=style&index=0&id=28be49a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28be49a7"]])

export default __exports__